export default __webpack_public_path__ + "static/Decentralization-c5a7c829a32d4365a863114f0b4a7990.svg";